import type { RecentSwap, RecentSwapContinuationStates } from './contracts'

interface ReadonlyValue<T> {
  readonly value: T
}

export interface RecentSwapsController {
  selectors: {
    swaps: ReadonlyValue<RecentSwap[]>
    isLoading: ReadonlyValue<boolean>
    continuationStates: ReadonlyValue<RecentSwapContinuationStates>
  }
  commands: {
    activate: () => void
    refresh: () => void
    subscribeContinuation: (
      read: () => { walletAddress: string | undefined; visible: boolean },
      subscribe: (notify: () => void) => () => void
    ) => () => void
    resume: (swap: RecentSwap, walletAddress: string | undefined) => Promise<void>
  }
}

let installed: RecentSwapsController | null = null

export const installRecentSwapsController = (controller: RecentSwapsController): void => {
  installed = controller
}

export const getRecentSwapsController = (): RecentSwapsController => {
  if (!installed) throw new Error('recent_swaps_controller_not_installed')
  return installed
}
